import { createContext, useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';

export const LogoContext = createContext(null);

export const LogoProvider = ({ children }) => {
    const [logoUrl, setLogoUrl] = useState(null);
    const [companyName, setCompanyName] = useState(null);

    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const res = await axiosInstance.get('/setting/ec-setting');
                if (res.data) {
                    setLogoUrl(res.data.logo_image_url);
                    setCompanyName(res.data.company_name);
                }
            } catch (err) {
                console.error('ロゴ情報の取得に失敗:', err);
            }
        };

        fetchLogo();
    }, []);

    return (
        <LogoContext.Provider value={{ logoUrl, companyName }}>
            {children}
        </LogoContext.Provider>
    );
};
